import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {TrackingService} from '@services/tracking.service';

@Component({
    selector: 'app-buy-congrats',
    templateUrl: './buy-congrats.component.html',
    styleUrls: ['./buy-congrats.component.scss']
})
export class BuyCongratsComponent implements OnInit {

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<BuyCongratsComponent>,
        public trackingService: TrackingService,
    ) {
    }

    ngOnInit(): void {
        this.trackingService.click('patrimoine_congrats_open', '');
    }

    onNoClick(): void {
        this.dialogRef.close(false);
    }
}
